import { useTranslation } from 'react-i18next';

export const useTexts = () => {
  const { t } = useTranslation();

  return { t };
};
